import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_MARKETING,
  REQUEST_CREATE_MASTER_MARKETING,
  SET_MASTER_MARKETING,
  SUCCESS_CREATE_MASTER_MARKETING,
  ERROR_GET_MASTER_MARKETING,
  ERROR_CREATE_MASTER_MARKETING,
  SET_MESSAGE_MASTER_MARKETING,
  SUCCESS_DELETE_MASTER_MARKETING,
  SUCCESS_UPDATE_MASTER_MARKETING,
  REQUEST_DELETE_MASTER_MARKETING,
  REQUEST_UPDATE_MASTER_MARKETING,
  ERROR_DELETE_MASTER_MARKETING,
  ERROR_UPDATE_MASTER_MARKETING,
} from "./marketingActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterMarketing: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterMarketing: [],
};

const marketings = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_MARKETING:
    case REQUEST_CREATE_MASTER_MARKETING:
    case REQUEST_DELETE_MASTER_MARKETING:
    case REQUEST_UPDATE_MASTER_MARKETING:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_MARKETING:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_MARKETING:
      return {
        ...state,
        busy: false,
        message: "",
        masterMarketing: action.payload,
      };

    case SUCCESS_CREATE_MASTER_MARKETING:
      return {
        ...state,
        busy: false,
        message: "",
        masterMarketing: [...state.masterMarketing, action.payload],
      };
    case SUCCESS_DELETE_MASTER_MARKETING:
      return {
        ...state,
        busy: false,
        message: "",
        masterMarketing: state.masterMarketing.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_MARKETING:
      return {
        ...state,
        busy: false,
        message: "",
        masterMarketing: state.masterMarketing.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_MARKETING:
    case ERROR_CREATE_MASTER_MARKETING:
    case ERROR_UPDATE_MASTER_MARKETING:
    case ERROR_DELETE_MASTER_MARKETING:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default marketings;

export function useMarketingMaster() {
  return useSelector((state: Record<string, any>) => state.marketings);
}
